<script lang="ts">
export default {
  name: 'NavigationActions',
}
</script>

<script setup lang="ts">
    import Zoom from './Zoom.vue';
    import HistoryNavigator from './HistoryNavigator.vue';
</script>

<template>
    <div class="tw:flex tw:row-start-2 tw:gap-1">
      <Zoom />
      <HistoryNavigator />
    </div>
</template>
